import { GA_APPLE } from '../constants/analytics';
import { IAnalyticsDimensionsProps } from './interfaces';
import { trackLoginSuccessful, trackLoginSuccessOneStep } from './login';
import { trackSocialAccountCreated } from './social';

export const trackAppleLoginSuccess = ({
    response,
    analytics,
}: {
    response: any;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    if (response.newUser ?? response['new_user']) {
        trackSocialAccountCreated({ socialProvider: GA_APPLE, analytics });

        trackLoginSuccessful({
            socialProvider: GA_APPLE,
            analytics,
        });
    } else {
        trackLoginSuccessOneStep({
            socialProvider: GA_APPLE,
            analytics,
        });
    }
};
